module.exports = __webpack_public_path__ + "files/b5f8a2454de910256051a1bd28bb97aa.png";